const SvgPropertyGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M2 6.896v-.063C2 3.612 4.686 1 8 1s6 2.612 6 5.833v.089c0 3.664-5.25 7.744-5.512 7.917a.82.82 0 01-.975 0C7.287 14.666 2 10.586 2 6.922v-.026zM8 9a2 2 0 100-4 2 2 0 000 4z' />
  </svg>
);

export default SvgPropertyGlyph;
